import http from './utils';
import { prefix, permissionPrefix, mockPrefix } from './constants';
import axios from 'axios';
import moment from 'moment';
const CancelToken = axios.CancelToken;

export const insightReport: (payload: any) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/report/insight`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const gptReport: (payload: any) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/report/gpt`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const gptExecutionsReport: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/report/gpt_executions`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const gptSetEmail: (payload: any) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/report/gpt_set_email`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const gptGetEmail: (payload: any) => Promise<any> | any = payload => {
  try {
    const startTime = payload?.start_time;
    const endTime = payload?.end_time;

    // 格式化为 YYYY-MM-DD，格式化失败则返回空数组
    const formattedStart = startTime
      ? moment(startTime).format('YYYY-MM-DD')
      : undefined;
    const formattedEnd = endTime
      ? moment(endTime).format('YYYY-MM-DD')
      : undefined;

    if (
      (startTime && formattedStart === 'Invalid date') ||
      (endTime && formattedEnd === 'Invalid date')
    ) {
      return Promise.resolve([]);
    }

    // 创建新对象，避免修改原参数
    const newPayload = {
      ...payload,
      start_time: formattedStart,
      end_time: formattedEnd,
    };

    return http({
      url: `${prefix}/report/gpt_get_email`,
      method: 'post',
      data: newPayload,
    }) as Promise<any>;
  } catch {
    return Promise.resolve([]);
  }
};

export const getPresetInfo: (payload: any) => Promise<any> | any = payload => {
  const { presetId } = payload || {};
  return http({
    url: `${permissionPrefix}/preset/guest_token/opinion/all/${presetId}`,
    method: 'get',
  }) as Promise<any>;
};

export const getReportTicket: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/getTicket`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const requestInsightSubscribeInfo: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/report/insight/subscribe_info`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const setReportInsightSubscribe: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/report/insight/subscribe`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const setReportInsightUnsubscribe: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/report/insight/unsubscribe`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getLookerSignedUrl: (payload: any) => Promise<any> | any = (
  payload: any,
) => {
  return http({
    url: `${prefix}/menu_ext`,
    method: 'post',
    data: payload,
    errorHandler: true,
  }) as Promise<any>;
};

export const getReportMenuTab: (
  payload: any,
  restConfig?: any,
) => Promise<any> | any = (payload, restConfig = {}) => {
  return http({
    url: `${prefix}/menu_tab`,
    method: 'post',
    data: payload,
    errorHandler: true,
    ...restConfig,
  }) as Promise<any>;
};

export type TPermissionLevel = 'private' | 'partial' | 'public';

export interface IAuthorizedUser {
  user_id: string;
  user_name: string;
  profile_pic?: string;
  email?: string;
  open_id?: string;
  department_name?: string;
}

export type TReportPermissionObjectType =
  | 'collect'
  | 'keyword_task'
  | 'repeat_summary';

export interface IReportPermissionTarget {
  object_type: TReportPermissionObjectType | string;
  object_id: number;
}

/** 创建类接口成功响应中用于权限接口的字段 */
export interface IReportPermissionCreateResponse {
  object_type?: TReportPermissionObjectType | string;
  object_id?: number;
}

export interface IReportPermissionInfo extends IReportPermissionTarget {
  permission_level: TPermissionLevel;
  authorized_user_count?: number;
  authorized_users_info?: IAuthorizedUser[];
  can_edit_permission: boolean;
}

export interface ISetReportPermissionParams extends IReportPermissionTarget {
  permission_level: TPermissionLevel;
  authorized_users: Array<{ user_id: string }>;
}

export interface ISearchPermissionUsersParams {
  keyword: string;
  page?: number;
  page_size?: number;
}

export interface ISearchPermissionUsersResponse {
  list?: IAuthorizedUser[];
  total?: number;
  page?: number;
  page_size?: number;
}

interface IRequestConfig<T> {
  data: T;
  cancelToken?: any;
  headers?: any;
}

export function getReportPermissionInfo(
  config: IRequestConfig<IReportPermissionTarget>,
): Promise<IReportPermissionInfo> {
  return http({
    url: `${prefix}/report/permission/info`,
    method: 'post',
    data: config.data,
    cancelToken: config.cancelToken,
    headers: config.headers,
  }) as Promise<IReportPermissionInfo>;
}

export function setReportPermission(
  config: IRequestConfig<ISetReportPermissionParams>,
): Promise<IReportPermissionInfo> {
  return http({
    url: `${prefix}/report/permission/set`,
    method: 'post',
    data: config.data,
    cancelToken: config.cancelToken,
    headers: config.headers,
    errorHandler: true,
  }) as Promise<IReportPermissionInfo>;
}

export function searchReportPermissionUsers(
  config: IRequestConfig<ISearchPermissionUsersParams>,
): Promise<ISearchPermissionUsersResponse> {
  return http({
    url: `${prefix}/report/permission/user/search`,
    method: 'post',
    data: {
      page: 1,
      page_size: 20,
      ...config.data,
    },
    cancelToken: config.cancelToken,
    headers: config.headers,
  }) as Promise<ISearchPermissionUsersResponse>;
}
